import React from 'react';
import './ui-components.scss'

const Spinner = ({className = ""}) => {
    return (
        <div className={`lds-dual-ring ${className}`}></div>
    );
};

export default Spinner;